import { render, staticRenderFns } from "./index.vue?vue&type=template&id=734ebc0b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=734ebc0b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734ebc0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734ebc0b')) {
      api.createRecord('734ebc0b', component.options)
    } else {
      api.reload('734ebc0b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=734ebc0b&scoped=true", function () {
      api.rerender('734ebc0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/psychological_test_dizney_characters/index.vue"
export default component.exports